import agent from 'superagent';
import { Query } from 'acast-reactor';
import baseUrl from 'server/routes/base-url';

export default Query.define('GetChannelsByCategory', (category, page) => {
  return new Promise((resolve, reject) => {
    agent
      .get(`${baseUrl}api/categories/${category}?page=${page || 0}`)
      .end((err, res) => {
        if (err) {
          return reject(err);
        }
        resolve(res.body);
      });
  });
});



// WEBPACK FOOTER //
// ./client/queries/get-channels-by-category.es6